// Old version of AttachmentData interface
// which is still used by check-in APIs
export interface OldAttachmentData {
  id: string;
  mimeType: string;
  docType: AttachmentDocType;
  classification: AttachmentClassification;
  name: string;
  description: string;
}

export interface AttachmentData {
  docId: string;
  mimeType: string;
  docType: AttachmentDocType;
  classification: AttachmentClassification;
  name: string;
  description: string;
  url: string;
  thumbUrl: string;
  isMain?: boolean;
}

export type AttachmentDocType = 'PHOTO' | 'PDF';

export enum AttachmentType {
  TokenDocument = 'TOKEN_DOCUMENT',
  TokenPhoto = 'TOKEN_PHOTO',
  VerificationPhoto = 'VERIFICATION_PHOTO',
  WitnessPhoto = 'WITNESS_PHOTO',
}

export enum AttachmentClassification {
  Face = 'FACE',
  GovtId = 'GOVTID',
  FaceAndGovtId = 'FACEANDGOVTID',
  QrCode = 'QRCODE',
  AssetPhoto = 'ASSET_PHOTO',
  AssetVerificationPhoto = 'ASSET_VERIFICATION_PHOTO',
  AssetWitnessPhoto = 'ASSET_WITNESS_PHOTO',
  ServicePhoto = 'SERVICE_PHOTO',
  ServiceVerificationPhoto = 'SERVICE_VERIFICATION_PHOTO',
  ServiceWitnessPhoto = 'SERVICE_WITNESS_PHOTO',
  Other = 'OTHER',
  AssetDocument = 'ASSET_DOCUMENT',
  ServiceDocument = 'SERVICE_DOCUMENT',
}

export interface CreateAttachmentInputData {
  mimeType: string;
  docType: AttachmentDocType;
  classification: AttachmentClassification;
  name: string;
  description: string;
  data?: string;
  isMain?: boolean;
}

export interface CreateQrAttachmentInputData {
  docType: AttachmentDocType;
  classification: AttachmentClassification;
  data: string;
  name?: string;
  description?: string;
}

export interface UpdateAttachmentInputData {
  mimeType?: string;
  docType?: AttachmentDocType;
  classification: AttachmentClassification;
  name?: string;
  description?: string;
  docId: string;
  data?: string;
  isMain?: boolean;
}

export interface UploadedAttachmentData {
  mimeType: string;
  docType: AttachmentDocType;
  classification: AttachmentClassification;
  docId: string;
  name: string;
  description: string;
  url?: string;
  isMain: boolean;
}

export enum EAttachmentUploadStatus {
  New = 'NEW',
  Uploaded = 'UPLOADED',
  Error = 'ERROR',
}
